import { Chat } from '@components/Chat'
import { ScreenLayout } from '@components/Layouts'
import { useI18n } from '@lib/i18n'
import { useIsFocused } from '@react-navigation/native'
import { useChatStore } from '@stores/chat'
import { useEffect } from 'react'

export function Messages() {
  const t = useI18n()
  const isFocused = useIsFocused()
  const [getChatMessages, markChatMessagesAsRead] = useChatStore((state) => [
    state.getChatMessages,
    state.markChatMessagesAsRead,
  ])

  useEffect(() => {
    if (isFocused) {
      getChatMessages().then(markChatMessagesAsRead)
    }
  }, [isFocused])

  return (
    <ScreenLayout title={t('screen.messages')} isStatic>
      <Chat />
    </ScreenLayout>
  )
}
